<!--资环行动-公司新闻-->
<template class="carbon">
  <div style="font-family: Alibaba">
    <!--CP端-->
    <div class="PC_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component class="act" :is='components.tail'></component>
        </keep-alive>
      </div>

      <!--导航图-->
      <div style="margin-bottom:80px">
        <el-carousel height="25vw" class='carousel_class'>
          <el-carousel-item v-for='item in zhActionList' :key='item.id'>
<!--            <div @click='jump(item)'>-->
              <el-image
                style="width: 100%;height: 25vw"
                v-if="item.fullPathUrl != null"
                :src="item.fullPathUrl"
              />
<!--            </div>-->
          </el-carousel-item>
        </el-carousel>
      </div>

      <!--资讯-->
      <el-row :span="24" class="box-width news">
        <el-col :md="12" :sm="12" :xs="24">
          <div class="news_img">
            <el-image
              alt="Image Description"
              :src="homeImgUrl"
              :fit="fit"></el-image>
          </div>
        </el-col>
        <el-col :md="12" :sm="12" :xs="24">
          <a href="#" @click='handleInformationDetail(item.id)'
             v-for="item in InformationListHome.slice(0, 4)"
             :key='item.id'
             @mouseover="updateHomeImgUrl(item.fullPathUrl)">
            <ul class="news_ul">
              <el-card shadow="hover"
                       :body-style="{ padding: '0px' }">
                <li class="li_img">
                  <el-image
                    alt="Image Description"
                    :fit="fit"
                    v-if="item.fullPathUrl != null"
                    :src="item.fullPathUrl"
                  ></el-image>
                </li>
                <li class="li_text">
                  <h4>{{ item.title }}</h4>
                  <span>{{ item.briefIntroduction}}</span>
                </li>
              </el-card>
            </ul>
          </a>
        </el-col>
      </el-row>

      <!--资讯列表标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameOne }}
          </h1>
          <p>{{ enNameOne }}</p>
        </div>
      </div>

      <!--资讯列表-->
      <el-card class="box-width newsList"
               shadow="hover"
               style="margin-bottom: 10px !important;height: 90px"
               v-for="item in newListAll"
               :body-style="{ padding: '10px' }"
               :key="item.id">
        <a href="#" @click='handleInformationDetail(item.id)'>
          <ul>
            <li>
              <el-image
                class="list_img"
                :fit='fit'
                v-if="item.fullPathUrl != null" :src="item.fullPathUrl"
              />
            </li>
            <li>
              <h4>{{ item.title }}</h4>
              <p>{{ item.releaseTime }}</p>
              <span class="text">{{ item.briefIntroduction }}</span>
            </li>
          </ul>
        </a>
      </el-card>
      <!--分页-->
      <div class="box-width">
        <!--分页-->
        <el-pagination style="text-align: right"
                       small
                       layout="prev, pager, next"
                       next-text="下一页"
                       prev-text="上一页"
                       v-show="total>0"
                       @prev-click='upPage'
                       @next-click='upPage'
                       @current-change='upPage'
                       :total='total'
                       :page.sync='queryParams.pageNum'
                       :page-size="queryParams.pageSize"
        >
        </el-pagination>
      </div>

      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

    <!--手机端-->
    <div class="mobile_box product">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class='paddingS'>
        <!--占位div-->
        <div style='height: 72px'></div>

        <!--主图-->
        <div class="main_img">
          <el-carousel height="200px" class='carousel_class'>
            <el-carousel-item v-for='item in zhActionList' :key='item.id'>
              <div>
                <el-image
                  :fit='fit'
                  v-if='item.fullPathUrl != null'
                  :src='item.fullPathUrl'
                />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <!--资讯主图-->
        <div class="news_img" style="border-radius: 6px;margin-bottom: 10px;position: relative">
          <a href="#" @click='handleInformationDetail(item.id)'>
          <el-image
            style="border-radius: 6px"
            alt="Image Description"
            :src="homeImgUrl"
            :fit="fit">
          </el-image>
            <h4 class="news_title">111</h4>
          </a>
        </div>
        <!--资讯列表-->
        <el-card class="box-width appNewsList"
                 shadow="hover"
                 style="margin-bottom: 10px !important;height: 74px"
                 v-for="item in newListAll"
                 :body-style="{ padding: '10px' }"
                 :key="item.id">
          <a href="#" @click='handleInformationDetail(item.id)'>
            <ul>
              <li>
                <el-image
                  class="list_img"
                  :fit='fit'
                  v-if="item.fullPathUrl != null" :src="item.fullPathUrl"
                />
              </li>
              <li>
                <h4>{{ item.title }}</h4>
                <p>{{ item.releaseTime }}</p>
                <span class="text">{{ item.briefIntroduction }}</span>
              </li>
            </ul>
          </a>
        </el-card>
        <!--分页-->
        <div class="box-width">
          <el-pagination style="text-align: right"
                         small
                         layout="prev, pager, next"
                         next-text="下一页"
                         prev-text="上一页"
                         v-show="total>0"
                         @prev-click='upPage'
                         @next-click='upPage'
                         @current-change='upPage'
                         :total='total'
                         :page.sync='queryParams.pageNum'
                         :page-size="queryParams.pageSize"
          >
          </el-pagination>
        </div>
        <!--插入尾部-->
        <div>
          <keep-alive>
            <component  :is='components.tail1'></component>
          </keep-alive>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import header from '../components/header.vue'
import footer from '../components/footer.vue'
import { findBanner, findEnName, getInformationlList, getInformationHomeList } from '@/api/zh'

export default {
  data () {
    return {
      tabId: null,
      components: {
        tail: header,
        tail1: footer
      },
      form: {
        name: '',
        phone: '',
        company: '',
        demand: ''
      },
      queryParams: {
        cnEnNameId: null,
        pageNum: 1,
        pageSize: 10
      },
      enNameOne: '',
      cnNameOne: '',
      activeName: 'second',
      fit: 'cover',
      url1: require('@assets/images/index/chanping1.png'),
      url: require('@assets/images/index/chanping.png'),
      url2: require('@assets/images/index/chanping2.png'),
      zhActionList: [],
      InformationListHome: [],
      newListAll: [],
      homeImgUrl: '',
      total: 0,
      cnEnNameId: null

    }
  },
  created () {
    this.tabId = this.$route.query.tabId
    this.selectBanner()
    this.selectEnName()
  },
  mounted () {
  },
  methods: {
    jump (raw) {
      if (raw.informationId === undefined || raw.informationId === '' || raw.informationId === null) {
      } else {
        this.$router.push({
          path: '/textContent',
          query: {
            id: raw.informationId,
            type: 2
          }
        })
      }
    },
    /** 轮播图 */
    selectBanner () {
      let that = this
      findBanner(this.tabId).then(res => {
        that.zhActionList = res.data
      })
    },
    /** 查询英文名称 */
    selectEnName () {
      let that = this
      findEnName(this.tabId).then(res => {
        that.enNameOne = res.data[0].enName
        that.cnNameOne = res.data[0].cnName
        that.selectInformationHome(res.data[0].id)
        that.cnEnNameId = res.data[0].id
        that.selectInformationAll(res.data[0].id)
      })
    },
    /** 查询资讯首页列表 */
    async selectInformationHome (cnEnNameId) {
      let that = this
      await getInformationHomeList(cnEnNameId).then(res => {
        that.InformationListHome = res.data

        // 检查是否有数据并且第一个item的fullPathUrl不为空
        if (that.InformationListHome.length > 0 && that.InformationListHome[0].fullPathUrl) {
          that.homeImgUrl = that.InformationListHome[0].fullPathUrl
        }
      })
    },
    /** 查询资讯列表 */
    async selectInformationAll (cnEnNameId) {
      let that = this
      this.queryParams.cnEnNameId = cnEnNameId
      await getInformationlList(this.queryParams).then(res => {
        that.total = res.total
        that.newListAll = res.rows
      })
    },
    /** 资讯详情 */
    handleInformationDetail: function (id) {
      this.$router.push({
        path: '/informationDetail',
        query: {
          informationId: id
        }
      })
    },
    /** 更新homeImgUrl */
    updateHomeImgUrl (fullPathUrl) {
      if (fullPathUrl != null) {
        this.homeImgUrl = fullPathUrl
      }
    },
    /** tab */
    handleClick (tab, event) {
      console.log(tab, event)
    },
    onSubmit () {
      console.log('submit!')
    },
    upPage (raw) {
      this.queryParams.pageNum = raw
      this.selectInformationAll(this.cnEnNameId)
    }

  }
}
</script>
